<template>
  <div class="container_1" style="position: relative;">
    <HeaderDjkx />
    <main class="main" v-if="tableList">
      <div class="table-title" style="height: 30px; border-top-left-radius: 20px; border-top-right-radius: 20px;">
        <div class="main-trs" style="border-top: 1px solid white; border-top-left-radius: 20px; border-top-right-radius: 20px;">
          <div class="t-th">商品</div>
          <div class="t-th">回购</div>
          <div class="t-th">销售</div>
          <div class="t-th">高/低</div>
        </div>
      </div>
      <div class="t-tr" v-if="GLOBAL.selectMapOther.map(item => {return item.state;})">
        <div v-for="(item, index) in GLOBAL.selectMapOther" :key="index" v-if="item.state">
          <div class="t-tr-sea" v-if="tableList[item.type]">
            <div class="t-td" style="color: #272727;font-size: 17px;">{{ item.name }}</div>
            <div class="t-td" :style="handleColor(item.type)" >{{ tableList[item.type].Buy === '0.00' ? '--' : tableList[item.type].Buy }}</div>
            <div class="t-td" :style="handleColor(item.type)">{{ tableList[item.type].Sell === '0.00' ? '--' : tableList[item.type].Sell }}</div>
            <div class="t-td">
              <div style="font-size: 14px;line-height: 27px;" :style="handleMaxColor(item.type)">
                {{ tableList[item.type].H === '0.00' ? '--' : tableList[item.type].H }}
              </div>
              <div style="font-size: 14px;line-height: 9px;" :style="handleMinColor(item.type)">
                {{ tableList[item.type].L === '0.00' ? '--' : tableList[item.type].L }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="explain">
        <div>
          <a style="color: #4C4141">声明：</a>
          <a style="color: red">以上价格为上金所及伦交所报价,仅供参考</a>
        </div>
        <div>电话：13612854870 15899854143</div>
        <div>地址：广东省深圳市罗湖区水贝万山D座一楼点金贵金属</div>
        <div>备案号：<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2021116286号-3</a></div>
      </div>
    </main>
  </div>
</template>
<script>
import HeaderDjkx from '@/components/HeaderDjkx.vue'
import { EventBus } from '../common/eventBus.js'

export default {
  name: 'Metals',
  data () {
    return {
      tableList: []
    }
  },
  components: {
    HeaderDjkx
  },
  computed: {
  },
  created () {
    EventBus.$on('tabListUpdated', updatedTabList => {
      this.tableList = updatedTabList
    })
    const favicon = document.querySelector('link[rel="icon"]')
    favicon.href = '../../static/favicon.ico'
  },
  mounted () {
  },
  methods: {
    handleColor (index) {
      let sell = parseFloat(this.tableList[index].Sell)
      let mean = (parseFloat(this.tableList[index].H) + parseFloat(this.tableList[index].L)) / 2
      return sell > mean ? 'color:#BC0A12;' : sell < mean ? 'color:#4D9F79' : 'color:black'
    },
    handleMaxColor (index) {
      return this.tableList[index].H === '-' ? 'color:#e8e8e8' : 'color:#BC0A12'
    },
    handleMinColor (index) {
      return this.tableList[index].L === '-' ? 'color:#e8e8e8' : 'color:#6BB193'
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Metals.vue